import PersonOutlined from '@mui/icons-material/PersonOutlined';
import { Avatar } from '@andritzot/metris-web-ui/data-display/avatar';
import { type SxProps, type Theme } from '@andritzot/metris-web-ui';

import { getUserProfilePicture } from '@/domain/user/utils';

interface UserAvatarProps {
  name?: string | null;
  pictureGuid?: string | null;
  size?: number;
  sx?: SxProps<Theme>;
}

const getInitials = (name?: string | null) =>
  (name ?? '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

export const UserAvatar = ({ name, pictureGuid, size = 28, sx }: UserAvatarProps) => {
  const initials = getInitials(name);

  return (
    <Avatar
      src={pictureGuid ? getUserProfilePicture(pictureGuid) : undefined}
      alt={name ?? undefined}
      sx={{ width: size, height: size, fontSize: size * 0.4, ...sx }}
    >
      {initials || <PersonOutlined sx={{ fontSize: size * 0.6 }} />}
    </Avatar>
  );
};
